export function parseJsonSafe(raw) {
  if (!raw) return null;
  if (typeof raw === "object") return raw;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function getMetaSocialFromMessage(message) {
  if (message?.metaSocial && typeof message.metaSocial === "object") {
    return message.metaSocial;
  }
  const root = parseJsonSafe(message?.json_whatsapp);
  if (!root) return null;

  const waRef = root.xpro_whatsapp_referral;
  if (waRef?.fromAd) {
    return {
      isStoryMention: false,
      isStoryReply: false,
      isAdReferral: true,
      isWhatsappCtwa: true,
      isReaction: false,
      isUnsupported: false,
      isAppointmentBooking: false,
      isProductInquiry: Boolean(root.xpro_thread?.referredProduct),
      isCatalogOrder: false,
      isGroupMessage: Boolean(root.xpro_group),
      storyId: null,
      lastReaction: root.xpro_meta_last_reaction || null,
      reactions: [],
    };
  }

  const event = root.xpro_meta_event ? String(root.xpro_meta_event) : null;
  if (!event && !root.meta_comment && !root.metaComment) return null;

  const metaComment = root.meta_comment || root.metaComment || null;
  const isCommentEvent =
    event === "instagram_comment" ||
    event === "facebook_comment" ||
    Boolean(metaComment?.commentId || metaComment?.comment_id);

  return {
    isStoryMention: event === "story_mention",
    isStoryReply: Boolean(root.entry?.[0]?.messaging?.[0]?.message?.reply_to?.story),
    isAdReferral: Boolean(root.xpro_meta_referral?.fromAd),
    isReaction: event === "reaction",
    isUnsupported: event === "unsupported",
    isAppointmentBooking: event === "appointment_booking",
    isComment: isCommentEvent,
    isInstagramComment: event === "instagram_comment",
    isFacebookComment: event === "facebook_comment",
    storyId: root.story_id || null,
    lastReaction: root.xpro_meta_last_reaction || null,
    reactions: Array.isArray(root.xpro_meta_reactions) ? root.xpro_meta_reactions : [],
  };
}

export function metaSocialLabel(metaSocial) {
  if (!metaSocial) return null;
  if (metaSocial.isWhatsappCtwa) return "Entrada via anúncio";
  if (metaSocial.isProductInquiry) return "Produto do catálogo";
  if (metaSocial.isCatalogOrder) return "Pedido do catálogo";
  if (metaSocial.isGroupMessage) return "Mensagem de grupo";
  if (metaSocial.isInstagramComment) return "Comentário no Instagram";
  if (metaSocial.isFacebookComment) return "Comentário no Facebook";
  if (metaSocial.isComment) return "Comentário no post";
  if (metaSocial.isStoryMention) return "Menção no story";
  if (metaSocial.isStoryReply) return "Resposta ao story";
  if (metaSocial.isAppointmentBooking) return "Agendamento Instagram";
  if (metaSocial.isUnsupported) return "Mensagem não suportada";
  if (metaSocial.isReaction) return "Reação";
  return null;
}

export function storyExpiredPlaceholder(metaSocial) {
  if (metaSocial?.isStoryMention) {
    return "O story mencionado não está mais disponível ou expirou.";
  }
  if (metaSocial?.isStoryReply) {
    return "O story respondido não está mais disponível ou expirou.";
  }
  return "Mídia indisponível ou expirada.";
}

export function formatMetaReferralLabel(metaReferral) {
  if (!metaReferral?.fromAd) return null;
  const headline = metaReferral.headline ? String(metaReferral.headline).trim() : "";
  if (headline) return `Anúncio: ${headline}`;
  return "Entrada via anúncio";
}
